__webpack_require__.p = "/wp-content/themes/biojamp/dist/";